<template>
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M82.9621 3.96171L88.5071 13.9003L99.871 13.2798L102.073 24.4455L113.073 27.367L111.717 38.6668L121.275 44.8443L116.494 55.1721L123.676 64.001L115.937 72.3458L120.039 82.9617L110.1 88.5067L110.721 99.8706L99.5549 102.073L96.6334 113.072L85.3336 111.717L79.1561 121.275L68.8283 116.494L59.9995 123.675L51.6547 115.937L41.0387 120.038L35.4937 110.1L24.1298 110.72L21.9274 99.5545L10.928 96.633L12.2837 85.3332L2.72546 79.1557L7.50668 68.8279L0.325188 59.9991L8.06385 51.6543L3.96212 41.0383L13.9007 35.4933L13.2802 24.1294L24.4459 21.927L27.3674 10.9276L38.6672 12.2833L44.8447 2.72506L55.1725 7.50627L64.0014 0.324782L72.3462 8.06344L82.9621 3.96171Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: "StarBadge"
}
</script>
